export type CreditsUsageEnvironment = 'production' | 'staging';

/** Builds a site-specific usage URL without depending on the browser hostname. */
export const getCreditsUsageUrl = (
	cloudId: string | undefined,
	environment: CreditsUsageEnvironment = 'production',
): string | undefined => {
	const siteId = cloudId?.trim();
	if (!siteId) {
		return undefined;
	}
	const origin =
		environment === 'staging' ? 'https://home.stg.atlassian.com' : 'https://home.atlassian.com';
	const query = new URLSearchParams({ cloudId: siteId });
	return `${origin}/usage?${query.toString()}`;
};
